import {useAppContext} from "./useAppContext";
import {useFragment} from "@apollo/client";
import {ITEM_QUESTION_CONNECTION_FRAGMENT} from "../definitions/fragments";
import {ItemClassificationType} from "../definitions/enums";
import {useMemo} from "react";
import {QuestionsModel} from "../models/view/questionsModel";

export const useProductQuestionConnectionFragment = () => {
    const {productId, primaryId} = useAppContext();

    const {complete, data} = useFragment({
        fragment: ITEM_QUESTION_CONNECTION_FRAGMENT,
        fragmentName: "QuestionConnectionFragment",
        from: {
            __typename: "QuestionConnection",
            id: primaryId ?? productId,
            type: primaryId ? ItemClassificationType.Primary : ItemClassificationType.Standalone
        },
    });

    const model = useMemo(() => complete && data ?
        new QuestionsModel(data) :
        new QuestionsModel({
            edges: [],
            pageInfo: {
                hasNextPage: false,
                hasPreviousPage: false,
                startCursor: undefined,
                endCursor: undefined
            }
        }), [complete, data]);

    return {loading: !complete, model};
}